import React, {useEffect, useState} from "react";
import SectionBox from "../../elements/SectionBox/SectionBox";
import Button from "../../elements/Button/Button";
import {useTranslation} from "react-i18next";
import {callAPI, formatCurrency, log} from "../../utils/utils";
import {useSnackbar} from "notistack";
import PaymentMethodUpdater from "./PaymentMethodUpdater";

import "./SettingsPage.scss";

const PaymentBox = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [ methodEditorOpen, setMethodEditorOpen] = useState(false);
  const [ paymentData, setPaymentData] = useState({method:"none", balance:0,minimum:0});
  const [ working, setWorking ] = useState(true);

  useEffect(() => {
    callAPI("payment").then((data) => {
      setPaymentData(data);
      setWorking(false);
    }).catch(error => {
      log("ERROR: ", error);
    });
  }, []);

  const requestPayment = () => {
    if (window.confirm(t("PaymentBox.RequestPaymentPrompt"))) {
      setWorking(true);
      callAPI("payment/request", "POST", {amount:0}).then(() => {
          enqueueSnackbar(t("PaymentBox.RequestSuccess"), {variant:'success'});
          setWorking(false);
        }).catch(() => {
          enqueueSnackbar(t("PaymentBox.RequestError"), {variant:'error'});
          setWorking(false);
        });
    }
  };

  return (
    <SectionBox headline={"PaymentBox.Headline"} info={"PaymentBox.InfoText"} width={1000} loading={working}>
      <div className={'payment__balance'}>
        <div>
          {t("PaymentBox.Balance")}
        </div>
        <div>
          {formatCurrency(paymentData.balance)}
        </div>
        <Button
          type="submit"
          size="large"
          variant="contained"
          color="primary"
          working={working}
          className="submit"
          disabled={paymentData.minimum > paymentData.balance}
          onClick={requestPayment}
        >
          {t("PaymentBox.RequestPayment")}
        </Button>
      </div>
      <div className={'payment__method'}>
        <div>
          {t("PaymentBox.Method")}
        </div>
        <div>
          {t("PaymentBox.MethodInfo." + paymentData.method)}{paymentData.account}
        </div>
        <Button
          type="submit"
          size="large"
          variant="contained"
          color="primary"
          working={working}
          className="submit"
          onClick={() => setMethodEditorOpen(true)}
        >
          {t("PaymentBox.EditPaymentMethod")}
        </Button>
      </div>
      {methodEditorOpen && <PaymentMethodUpdater onClose={() => setMethodEditorOpen(false)}/>}
    </SectionBox>
  );
}

export default PaymentBox;